import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import ModalFeedBack from "../../../components/ModalFeedBack";
import { PerguntaTriagemPaVirtual } from "../../../interfaces/entities/PerguntaTriagemPaVirtual";
import { RespostaTriagemPaVirtual } from "../../../interfaces/entities/RespostaTriagemPaVirtual";
import { OpcoesResultExame } from "../../../interfaces/entities/PAVirtual/OpcoesResultExame";
import { TipoOrientacaoTriagem } from "../../../interfaces/entities/TipoOrientacaoTriagem";
import { TipoAtendRetorno } from "../../../interfaces/entities/PAVirtual/TipoAtendRetorno";
import { getDirecionamento, getQuestoesRetorno, getTriagem, salvarRespQuest } from "../../../services/SaudeOnlineService";
import { sxBoxScreening, sxButton, sxScreeningFormLabel, sxScreeningRadioGroup } from "./sxProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import CircularProgressLoading from "../../../components/Accessibility/CircularProgressLoading";
import AudioLoadingDescription from "../../../components/Accessibility/AudioLoadingDescription";
import { getUrlNavegacaoTeleorient } from '../../../services/LoginService';
import { useNavigate } from 'react-router-dom';
import './styles.css'


import pa_disable from "../../../assets/images/pa-disable.png";
import pa_enable from "../../../assets/images/pa-enable.png";
import tele_disable from "../../../assets/images/tele-disable.png";
import tele_enable from "../../../assets/images/tele-enable.png";


const StepDetalheSintoma = (props: {
  backStep: () => void,
  nextStep: () => void,
  sintoma: TipoOrientacaoTriagem | null
  endScreening: () => void,
  setTipoAtendPaVirtual: (tipoAtend: TipoAtendRetorno) => void
}) => {

  const { backStep, nextStep, sintoma, endScreening, setTipoAtendPaVirtual } = { ...props };
  const [questoesTriagem, setQuestoesTriagem] = useState<PerguntaTriagemPaVirtual[]>([]);
  const [respostasTriagem, setRespostasTriagem] = useState<RespostaTriagemPaVirtual[]>([]);
  const [allowProceed, setAllowProceed] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [showModalFeedBack, setShowModalFeedBack] = useState<boolean>(false);
  const [opcoesAgendamento, setOpcoesAgendamento] = useState<boolean>(false);
  const [messageModalFeedBack, setMessageModalFeedBack] = useState<string>('Erro');
  const mobileScreen = useMediaQuery('(max-width: 768px)');
  const [opcoesResultExame, setOpcoesResultExame] = useState<OpcoesResultExame[]>([]);
  const navigate = useNavigate();
  const accessibility = useAccessibility();

  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);


  useEffect(() => {
    fetchTriagem(sintoma!.codTipoTeleOrientacao);
  }, []);

  const getIcon = (item: any) => {
    if (!item.teleorientacao) {
      return item.selecionado ? pa_enable : pa_disable;
    }

    if (item.teleorientacao) {
      return item.selecionado ? tele_enable : tele_disable;
    }

    return undefined;
  };


  const openModalError = (title: string, subtitle: string) => {
    setModalFeedback({
      icon: 'error',
      title: title,
      subTitle: subtitle,
      textButton: 'Fechar',
      showButtonModal: true,
      closeAction: () => setModalFeedback(null),
      buttonAction: () => setModalFeedback(null)
    });
  }


  const fetchTriagem = async (codTipoTeleOrientacao: string) => {
    setLoading(true);
    setOpcoesAgendamento(false);
    try {
      const result = await getTriagem(codTipoTeleOrientacao);
      if (result?.status === 200) {
        let questoesTriagem: PerguntaTriagemPaVirtual[] = result.data;
        setQuestoesTriagem(questoesTriagem);
        initializeRespostas(questoesTriagem);
      } else {
        console.error('Falha ao buscar tipos de orientação TRIAGEM.');
      }
    } catch (error: any) {
      console.error('Erro ao buscar tipos de orientação TRIAGEM:', error);
    }
    setLoading(false);
  };


  const initializeRespostas = (questions: PerguntaTriagemPaVirtual[]) => {
    const initialRespostas: RespostaTriagemPaVirtual[] = questions.map(question => {
      return {
        idRespQuestBenef: question.idRespQuestBenef,
        idQuestaoTeleOrientAnterior: question.idQuestaoTeleOrientAnterior,
        lstQuestoesTriagem: question.lstQuestoesTriagem.map(item => ({
          idItemQuestaoTeleOrient: item.idItemQuestaoTeleOrient,
          vlrItem: item.vlrItem,
          resposta: item.resposta,
        }))
      };
    });
    setRespostasTriagem(initialRespostas);
  };

  const handleModalFeedBack = (): void => {
    setShowModalFeedBack(show => !show);
  }

  const handleSelect = (index: any) => {
    const novaLista = [...opcoesResultExame];
    novaLista.forEach((item) => (item.selecionado = false));
    novaLista[index].selecionado = true;
    setOpcoesResultExame(novaLista);
    console.log("Selecionado:", novaLista[index]);
  };

  const handleAnswerQuestion = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const idRespostaSelecionada = event.target.value;

    const updatedRespostas = respostasTriagem.map((questao, qIndex) => {
      if (qIndex !== index) return questao;

      return {
        ...questao,
        lstQuestoesTriagem: questao.lstQuestoesTriagem.map((item) => ({
          ...item,
          resposta:
            item.idItemQuestaoTeleOrient === idRespostaSelecionada
              ? "S"
              : "N",
        })),
      };
    });

    setRespostasTriagem(updatedRespostas);
    setAllowProceed(allQuestionsAnswered(updatedRespostas));
  };


  const isButtonDisabled = () => {

    const selecionados = opcoesResultExame.filter(item => item.selecionado);

    if (opcoesResultExame.length > 0 && selecionados.length === 0) {
      return true;
    }
    else {
      return !allowProceed;
    }
  };



  const getRedirecionamentoBenef = async () => {
    setLoading(true);
    const result = await getDirecionamento(respostasTriagem.at(0)!.idRespQuestBenef, sintoma!.codTipoTeleOrientacao);
    if (result?.status === 200) {
      const tipoAtendRetorno: TipoAtendRetorno = result.data.redirecionar;
      setTipoAtendPaVirtual(tipoAtendRetorno);
      switch (tipoAtendRetorno) {
        case 'RESULEXAMDENGUE':
          fetchTriagem("EXAMDENGUE");
          setAllowProceed(false);
          break;
        case 'AGENDDENGUE':

          if (respostasTriagem.at(0)!.lstQuestoesTriagem.at(0)!.resposta == "S") {
            if (opcoesResultExame.length == 0) {
              setOpcoesResultExame(result.data.opcoesSelecao);
              setOpcoesAgendamento(true);
            }
            else {
              const selecionados = opcoesResultExame.filter(item => item.selecionado);
              if (selecionados.length > 0) {
                if (selecionados[0].teleorientacao) {
                  navigate('/saudeOnline/teleorientacaoSaude')
                }
                else {
                  nextStep();
                }
              }
              else {
                openModalError("Atenção", "Selecione uma opção, Teleorientação ou PA Virtual.");
              }
            }
          }
          else {
            nextStep();
          }

          break;
        case 'PRESENCIAL':
          endScreening();
          break;
        case 'ORIENTACAO':
          await generateNewQuestionnaire();
          break;
        case 'VIRTUAL': case 'VIRTUAL-AGENDA': case 'ENCAMINHA':
          nextStep();
          break;
      }
    } else {
      setMessageModalFeedBack('Erro ao validar respostas');
      handleModalFeedBack();
    }
    setLoading(false);
  }

  const generateNewQuestionnaire = async () => {
    const resultQuestoesRetorno = await getQuestoesRetorno();
    if (resultQuestoesRetorno?.status === 200) {
      const newQuestions: PerguntaTriagemPaVirtual[] = resultQuestoesRetorno.data;
      setQuestoesTriagem(newQuestions);
      setRespostasTriagem([]);
      initializeRespostas(newQuestions);
      setAllowProceed(false);
    } else {
      setMessageModalFeedBack('Erro ao avançar questionário')
      handleModalFeedBack();
    }
  }

  const saveAnswers = async () => {
    const result = await salvarRespQuest(respostasTriagem);
    if (result?.status === 200) {
      await getRedirecionamentoBenef();
    } else {
      setMessageModalFeedBack('Erro ao salvar respostas');
      handleModalFeedBack();
    }
  };

  const allQuestionsAnswered = (respostas: RespostaTriagemPaVirtual[]): boolean => {
    return respostas.every(questao =>
      questao.lstQuestoesTriagem.some(item =>
        item.resposta === 'S'
      )
    );
  };

  return (
    <>
      <AudioLoadingDescription loading={loading} />
      {loading ? <CircularProgressLoading /> :
        <Box sx={sxBoxScreening}>
          <Typography fontFamily={'Unimed-Sans'} style={accessibility.textStyleAccessibility} color={'#383838'} component="h2">
            <b>Sintoma: {sintoma!.descr}</b>
          </Typography>
          {questoesTriagem.map((questao, index) => (
            <FormControl component={"fieldset"} key={questao.idQuestaoTeleOrient} fullWidth>
              <FormLabel style={accessibility.textStyleAccessibility} id={questao.idQuestaoTeleOrient} sx={sxScreeningFormLabel}>{questao.txtQuestao}</FormLabel>
              <RadioGroup
                sx={sxScreeningRadioGroup}
                row
                value={
                  respostasTriagem[index]?.lstQuestoesTriagem.find(i => i.resposta === 'S')
                    ?.idItemQuestaoTeleOrient || ''
                }
                onChange={(event) => handleAnswerQuestion(event, index)}
              >
                {questao.lstQuestoesTriagem.map((itemQuestao) => (
                  <FormControlLabel
                    key={itemQuestao.idItemQuestaoTeleOrient}
                    value={itemQuestao.idItemQuestaoTeleOrient}
                    control={<Radio style={accessibility.textStyleAccessibility} />}
                    label={<span className="pa-virtual-option" style={accessibility.textStyleAccessibility}>{itemQuestao.txtItemQuestao}</span>}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          ))}

          {opcoesResultExame.length > 0 &&
            <Typography fontFamily={'Unimed-Sans'} style={accessibility.textStyleAccessibility} color={'#383838'} component="h2">
              <div>
                <b>Como você deseja seguir com seu atendimento?</b>
              </div>
              <div style={{
                marginTop:"10px",
                display: "flex",
                justifyContent: "center"
              }}>
                {opcoesResultExame.map((item, index) => (
                  <div
                    className="opcao-exame"
                    key={index}
                    onClick={() => handleSelect(index)}>

                    <img src={getIcon(item)} width={40} />

                    <div>
                      <div className="corpo-recomendacao">
                        <span>{item.nome}</span>

                        {item.recomendacao && (
                          <div className="container-recomendacao">
                            <div className="balao">
                              {item.recomendacao}
                            </div>
                          </div>
                        )}
                      </div>

                      <div style={{ fontSize: "14px", color: "#666" }}>
                        {item.descricao}
                      </div>


                    </div>
                  </div>
                ))}
              </div>

            </Typography>




          }
          <Button
            type="button"
            variant="contained"
            size="large"
            onClick={saveAnswers}
            sx={sxButton}
            style={accessibility.buttonStyleAccessibility}
            disabled={isButtonDisabled()}
            fullWidth={mobileScreen}>
            <span style={accessibility.buttonTextStyleAccessibility}>
              PROSSEGUIR
            </span>
          </Button>
          <button className="back-button" onClick={backStep} style={accessibility.textStyleAccessibility} aria-label="voltar para queixas">
            <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faChevronLeft} />&nbsp;&nbsp;<u>Voltar</u>
          </button>
        </Box>
      }
      <ModalFeedBack
        icon={modalFeedback?.icon as 'success' | 'warning' | 'error'}
        showModal={!!modalFeedback}
        showButtonModal={modalFeedback?.showButtonModal}
        handleButtonModal={modalFeedback?.buttonAction}
        handleShowModal={modalFeedback?.closeAction}
        textButton="FECHAR"
        title={modalFeedback?.title as string} subTitle={modalFeedback?.subTitle as string}
      />
    </>
  )
}

export default StepDetalheSintoma;